import { assign } from 'fsm';
import { fetchPropertyDefinitions } from './client';
export const machine = {
  initial: 'initializing',
  states: {
    initializing: {
      always: [{
        target: 'fetching'
      }]
    },
    idle: {
      on: {
        FETCH: 'fetching'
      }
    },
    fetching: {
      invoke: {
        src: 'fetchPropertyDefinitions',
        onDone: {
          target: 'idle',
          actions: ['setPropertyDefinitions']
        },
        onError: 'error'
      },
      tags: ['loading']
    },
    error: {
      tags: ['error']
    }
  },
  actions: {
    setPropertyDefinitions: assign((_context, event) => {
      return {
        propertyDefinitions: event.data
      };
    })
  },
  guards: {},
  services: {
    fetchPropertyDefinitions: context => fetchPropertyDefinitions(context.objectTypeId)
  }
};